import ReactRailsUJS from 'react_ujs'
import { setReactConstructor } from '../helpers/ViteHelper'

const modules = import.meta.globEager([
  '~/pages/**/*.{js,jsx,ts,tsx}',
  '~/partials/**/*.{js,jsx,ts,tsx}',
])

setReactConstructor(ReactRailsUJS, modules)
